import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    open:false,
    images: [],
    default:''
};

const imagedlgSlice = createSlice({
    name: 'imagedlg',
    initialState,
    reducers: {
        imageopen: (state, action) => {
            return Object.assign({}, state, { open: true, images: action.payload.images, default: action.payload.default})
        },
        imageclose: (state, action) => {
            return Object.assign({}, state, { open: false})
        },
        setimagelist: (state, action) => {
            return Object.assign({}, state, { images: action.payload })
        },
    },
});

export const {
    imageopen, imageclose, setimagelist
} = imagedlgSlice.actions

export default imagedlgSlice;

